// Phase 37: localized display name for a category.
//
// Canonical name (zh-Hant) lives in `categories.name` and is the
// stable key used in UNIQUE indexes and as the denormalized
// `transactions.category_name` written at tx-create time. To show
// the user's chosen language, look up `categories.<canonical>`
// in the active locale; if missing (user-created category with no
// translation entry), fall back to the canonical name itself.
//
// Usage:
//   const { t } = useI18n();
//   <span>{categoryLabel(cat, t)}</span>
//   <span>{categoryLabel({ name: tx.category_name }, t)}</span>

export function categoryLabel(cat, t) {
  const canonical = (cat && cat.name) || '';
  if (!canonical) return '';
  // t supports (key, vars, defaultValue); the i18n resolver falls
  // back to zh-Hant, then to defaultValue if the key is missing.
  return t(`categories.${canonical}`, undefined, canonical);
}